import axios from "axios";
import authHeader from "../../api/services/token.interceptor";
const API_URL = process.env.REACT_APP_API_URL;

// Nouvelle fonction pour vérifier le crédit de l'utilisateur
export const fetchCompanyCredit = async (companyId) =>
  await axios.get(
    `${API_URL}/recouv/account/company_accounts/?company_id=${companyId}`,
    {
      headers: authHeader(),
    }
  );

export const fetchSearch = async (search) =>
  await axios.post(
    `${API_URL}/recouv/search`,
    JSON.stringify({ value: search }),
    {
      headers: authHeader(),
    }
  );

export const fetchSearchAlerte = async (search) =>
  await axios.post(
    `${API_URL}/recouv/search-alert`,
    JSON.stringify({ value: search }),
    {
      headers: authHeader(),
    }
  );

export const fetchSearchDetail = async (rccm) =>
  await axios.post(
    `${API_URL}/recouv/detail`,
    JSON.stringify({ value: rccm }),
    {
      headers: authHeader(),
    }
  );

export const fetchSearchDirigeantsDetail = async (paylaod) =>
  await axios.post(`${API_URL}/recouv/dirigeant-detail`, paylaod, {
    headers: authHeader(),
  });

export const fetchSearchDecision = async (url, denomination) =>
  await axios.post(
    `${API_URL}/${url}`,
    JSON.stringify({ value: denomination }),
    {
      headers: authHeader(),
    }
  );

export const paginateFetchSearchDecision = async (url, denomination, nom_commercial) =>
  await axios.post(url, JSON.stringify({ value: denomination ?? nom_commercial }), {
    headers: authHeader(),
  });

export const fetchSearchAnnonces = async (denomination) =>
  await axios.get(`${API_URL}/formalite/annonces-v2/?denomination=${encodeURIComponent(denomination)}`, {
    headers: authHeader(),
  });

export const fetchSearchMarchesPublics = async (denomination) =>
  await axios.get(`${API_URL}/formalite/marches-publics/?attributaire=${encodeURIComponent(denomination)}`, {
    headers: authHeader(),
  });

// Pagination Annonces légales
export const paginateFetchSearchAnnonces = async (url) =>
  await axios.get(url, {
    headers: authHeader(),
  });

// Pagination Marchés publics
export const paginateFetchSearchMarchesPublics = async (url) =>
  await axios.get(url, {
    headers: authHeader(),
  });

// Nouvelle API unifiée pour récupérer toutes les entités liées à une entreprise
export const fetchCompanyEntities = async (denomination) =>
  await axios.get(
    `${API_URL}/formalite/companies/entities-by-name/?name=${encodeURIComponent(denomination)}&exact=true`,
    {
      headers: authHeader(),
    }
  );